import Context from './PlayerTimeContext';
import Provider from './PlayerTimeProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
